module.exports = __webpack_public_path__ + "static/img/807.10f59e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/807.jpg
// module id = wo2R
// module chunks = 0